// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Curve from '../../../addons/particlepack/curves/Curve';

/**
 * A curve with a constant value.
 */
class ConstantCurve extends Curve {
  /**
   * @param {object} [options]
   * @param {number} [options.value=1]
   */
  constructor(options) {
    options = options || {};

    super(options);

    /**
     * @type {number}
     */
    this.value = options.value !== undefined ? options.value : 1;
  }

  toGLSL() /* timeVariableName, lerpValueVariableName */{
    return Curve.numberToGLSL(this.value);
  }

  integralToGLSL(timeVariableName/* , lerpValueVariableName */) {
    const value = Curve.numberToGLSL(this.value);
    return `(${value}*${timeVariableName})`;
  }

  getValueAt() /* t, lerpFactor */{
    return this.value;
  }

  getIntegralValueAt(t /* , lerpFactor */) {
    return this.value * t;
  }
}

export default ConstantCurve;
